import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import { ref } from 'vue';
import {
  BaseButton,
  XrkMessage,
  BaseFormRef,
  BaseDialog
} from 'xrk-components';
import { addIndividual, addCheck } from '../data-source/apis';
import { AddIndividualParams } from '../data-source/types';
import { DetailLicense } from './detail';


export default /*#__PURE__*/_defineComponent({
  __name: 'add-one-dialog',
  props: {
    remove: {}
  },
  emits: ['success'],
  setup(__props: any, { emit: __emit }) {

const emits = __emit;
const props = __props;

const ruleFormRef = ref<BaseFormRef>();
const formData = ref<AddIndividualParams>({
  businessIndividualId: null,
  individualName: '',
  businessParkId: null,
  operator: '',
  phone: '',
  entpCertType: null,
  entpCertNo: '',
  entpCertPic: '',
  expiraStart: '',
  expiraEnd: '',
  enable: null,
  registerAt: '',
  declareMethod: null,
  taxAssessmentMethod: null,
  invoiceType: 3,
  invoiceItemIdList: [],
  individualType: null,
  _expira: [],
  _fileList: [],
  _invoiceType: [1, 2],
  parkType: null,
  isPermanent: 0
});
const onConfirm = async () => {
  await ruleFormRef.value.validate();
  const { data: addCheckData } = await addCheck({
    operator: formData.value.operator,
    phone: formData.value.phone
  });
  if (addCheckData.status === 1) {
    await addIndividual(formData.value);
    emits('success');
    props.remove();
  } else {
    XrkMessage.error('当前个体户不可新增');
  }
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_unref(BaseDialog), {
    width: "960px",
    title: "单独添加",
    "model-value": true,
    "show-close": true,
    "close-on-press-escape": true,
    "close-on-click-modal": false
  }, {
    footer: _withCtx(() => [
      _createVNode(_unref(BaseButton), {
        onClick: _ctx.remove,
        type: "default"
      }, {
        default: _withCtx(() => [
          _createTextVNode("取消")
        ]),
        _: 1
      }, 8, ["onClick"]),
      _createVNode(_unref(BaseButton), {
        click: onConfirm,
        type: "primary"
      }, {
        default: _withCtx(() => [
          _createTextVNode("确定")
        ]),
        _: 1
      })
    ]),
    default: _withCtx(() => [
      _createVNode(_unref(DetailLicense), {
        ref_key: "ruleFormRef",
        ref: ruleFormRef,
        type: "add",
        columnCount: 2,
        modelValue: formData.value,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((formData).value = $event))
      }, null, 8, ["modelValue"])
    ]),
    _: 1
  }))
}
}

})